import { size as _size } from 'lodash-es';
import { dbCategories } from 'dbServer/collections';

export const fetchCategories = async () => {
	const categoriesData = await dbCategories.getCategories();
	return !_size(categoriesData) ? [] : categoriesData;
};
